import ComplexTable from 'components/table';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import Button from 'components/button';
import { HiArrowRight } from 'react-icons/hi';
import UseApi from 'hooks/useApi';
import { IFilter } from 'types';
import { encodeFilters } from 'utils';

type RowObj = {
  _id: string;
  email: string;
  createdAt: string;
  description: boolean;
};

const columnHelper = createColumnHelper<RowObj>();
const columns = [
  columnHelper.accessor('email', {
    id: 'email',
    header: () => <p className="  ">EMAIL</p>,
    cell: (info) => <p className="  ">{info.getValue()}</p>,
  }),
  columnHelper.accessor('createdAt', {
    id: 'date',
    header: () => <p className="  ">DATE</p>,
    cell: (info) => <p className="  ">{info.getValue().substring(0, 10)}</p>,
  }),
  columnHelper.accessor('description', {
    id: 'description',
    header: () => <p className="  ">DESCRIPTION</p>,
    cell: (info) => (
      <p className="  ">{info.getValue()?.toString().substring(0, 30)}...</p>
    ),
  }),
  columnHelper.accessor('_id', {
    id: '_id',
    header: () => <p className="  ">DETAILS</p>,
    cell: (info) => (
      <Link key={1} to={info.getValue()}>
        <Button type="icon">
          <HiArrowRight />
        </Button>
      </Link>
    ),
  }),
];
const filters: IFilter[] = [
  { key: 'email', type: 'text', label: 'Email' },
  { key: 'createdAtFrom', type: 'date', label: 'From Date' },
  { key: 'createdAtTo', type: 'date', label: 'To Date' },
  {
    key: 'showArchived',
    type: 'select',
    options: ['false', 'true'],
    label: 'Archived',
  },
];

const ContactForm = () => {
  const { getApi } = UseApi();

  async function fetchData(
    options: any,
    filterState: { [key: string]: string },
  ) {
    const { pageIndex, pageSize } = options;
    const response = await getApi(
      `contactUs?page=${pageIndex + 1}&limit=${pageSize}${encodeFilters(
        filterState,
      )}`,
    );
    const data = response.data.data.contactForms;
    const pageCount = response.data.data.totalPages;
    return {
      rows: data,
      pageCount,
    };
  }
  return (
    <div>
      <ComplexTable columns={columns} fetchData={fetchData} filters={filters} />
    </div>
  );
};
export default ContactForm;
